import client, {QueryOptions} from "@irati/utils/services/apollo"
import {DealCategory, Tag} from "@irati/types"
import tagService from "@irati/tag/services/tag"
import dealCategoriesForCurrentPackageQuery, {dealCategoriesForCurrentPackageKey} from "./queries/dealCategoriesForCurrentPackage"
import rewardCategoriesForCurrentPackageQuery, {rewardCategoriesForCurrentPackageKey} from "./queries/rewardCategoriesForCurrentPackage"

export interface CatergoryAndTag {
  url: string | undefined
  tags: string | undefined
  category: DealCategory | undefined
}
class DealCategories {
  get(id: string, options: QueryOptions = {}): Promise<Tag> {
    return tagService.get({id, withChildren: true}, options)
  }

  listForCurrentPackage(options: QueryOptions = {}): Promise<DealCategory[]> {
    return client.query({...options, query: dealCategoriesForCurrentPackageQuery}).then(({data}) => {
      return data[dealCategoriesForCurrentPackageKey].results
    })
  }
  listForRewardPackage(options: QueryOptions = {}): Promise<DealCategory[]> {
    return client.query({...options, query: rewardCategoriesForCurrentPackageQuery}).then(({data}) => {
      return data[rewardCategoriesForCurrentPackageKey].results
    })
  }
  getCategoryBasedOnTag(tagIdOrUrl: string): Promise<CatergoryAndTag> {
    return categoriesService.listForCurrentPackage().then((categories) => {
      let url = "/categories"
      let tags
      let category
      for (const c of categories) {
        for (const t of c?.tags || []) {
          if (t.url === tagIdOrUrl || t.uuid === tagIdOrUrl) {
            category = c
            tags = t.url
            url = `/categories/${c.url}?tags=${t.url}`
            break
          }
        }
      }
      return {url, tags, category}
    })
  }
}

const categoriesService = new DealCategories()

export default categoriesService
